export enum GraphicBehaviorType {
    FAN = 'FAN',
    FAN_ROOM = 'FAN_ROOM',
    FAN_HOOD = 'FAN_HOOD',
    BLOWER = 'SENSOR_BLOWER',
    BLOWER_UNOCCUPIED = 'SENSOR_BLOWER_UNOCCUPIED',
    GAUGE = 'GAUGE',
    ALERT = 'ALERT',
    WASH = 'WASH',
    LIGHT = 'LIGHT',
    LIGHT_HOOD = 'LIGHT_HOOD',
    LIGHT_ROOM = 'LIGHT_ROOM',
    RELATIVE_HUMIDITY_SENSOR = 'RELATIVE_HUMIDITY_SENSOR',
    CLIMATE_CONTROL_STATE_SENSOR = 'CLIMATE_CONTROL_STATE_SENSOR',
    TEMPERATURE_SENSOR = 'TEMPERATURE_SENSOR',
    TEMPERATURE_HOT_SENSOR = 'TEMPERATURE_HOT_SENSOR',
    TEMPERATURE_HOT_UNOCCUPIED_SENSOR = 'TEMPERATURE_HOT_UNOCCUPIED_SENSOR',
    TEMPERATURE_COLD_SENSOR = 'TEMPERATURE_COLD_SENSOR',
    TEMPERATURE_COLD_UNOCCUPIED_SENSOR = 'TEMPERATURE_COLD_UNOCCUPIED_SENSOR',
    TEMPERATURE_DIFFERENTIAL_SENSOR = 'TEMPERATURE_DIFFERENTIAL_SENSOR',
    OCCUPIED_SENSOR = 'OCCUPIED_SENSOR',
}
